<template>
  <div class="forward-message">
    <ElDialog
        v-model="isShow"
        title="转发消息给"
        :width="412"

        class="forward-message-dialog"
        destroy-on-close
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="handleClose"
    >
      <div class="forward-message__body">
        <ElInput
            v-model="searchKeyword"
            placeholder="搜索"
            clearable
            size="small"
            class="search-input"
        />

        <div class="contact-sections">
          <!-- <div v-if="recentContacts.length" class="contact-section">
            <div class="section-title">最近对话</div>
            <div
                v-for="item in filteredRecentContacts"
                :key="item.id"
                class="contact-item"
                @click="toggleSelect(item)"
            >
              <el-avatar :size="36" :src="item.avatar">
                {{ item.name?.charAt(0) || "?" }}
              </el-avatar>
              <span class="contact-name">{{ item.name }}{{ item.phone ? ` ${item.phone}` : "" }}</span>
              <el-checkbox
                  :model-value="isSelected(item)"
                  @update:model-value="toggleSelect(item)"
                  @click.stop
              />
            </div>
          </div> -->
          <div class="contact-section" style="height: 400px;overflow: hidden auto;" @scroll="handleContactsScroll">
            <div class="section-title">其他联系人</div>
            <div
                v-for="item in filteredOtherContacts"
                :key="item.id"
                class="contact-item"
                @click="toggleSelect(item)"
            >
              <el-avatar :size="36" :src="item.avatar">
                {{ item.name?.charAt(0) || "?" }}
              </el-avatar>
              <span class="contact-name">
                {{ item.name }}
                <!-- {{ item.phone ? ` ${item.phone}` : "" }} -->
              </span>
              <el-checkbox
                  :model-value="isSelected(item)"
                  @update:model-value="toggleSelect(item)"
                  @click.stop
              />
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="forward-message__footer">
          <ElButton
              class="btn-send"
              type="primary"
              size="small"
              :loading="sending"
              :disabled="selectedIds.length === 0 || sending"
              @click="handleSend"
          >
            发送
          </ElButton>
        </div>
      </template>
    </ElDialog>
  </div>
</template>

<script>
import { getAllContact } from "@/api/whatsapp";

export default {
  name: "ForwardMessage",
  emits: ["send", "close"],
  props: {
    recentContacts: {
      type: Array,
      default: () => [
        {id: "1", name: "娜梦烊", avatar: ""},
        {id: "2", name: "Louise Martinez", avatar: ""},
      ],
    },
  },
  data() {
    return {
      isShow: false,
      searchKeyword: "",
      selectedIds: [],
      forwardPayload: null,
      sending: false,
      // 其他联系人数据
      otherContactsInternal: [],
      loadingOtherContacts: false,
      otherContactsHasMore: true,
      otherContactsPagination: {
        limit: 10,
        offset: 1,
        sortBy: "",
        sortOrder: "",
      },
    };
  },
  computed: {
    filteredRecentContacts() {
      return this.filterContacts(this.recentContacts);
    },
    filteredOtherContacts() {
      return this.filterContacts(this.otherContactsInternal);
    },
  },
  methods: {
    open(payload) {
      this.isShow = true;
      this.searchKeyword = "";
      this.selectedIds = [];
      this.forwardPayload = payload;
      this.sending = false;
      // 重置分页并加载第一页
      this.otherContactsPagination.offset = 1;
      this.otherContactsHasMore = true;
      this.otherContactsInternal = [];
      this.loadOtherContacts();
    },
    handleContactsScroll(e) {
      if (this.loadingOtherContacts) return;
      if (!this.otherContactsHasMore) return;

      const el = e?.target;
      if (!el) return;

      const threshold = 40;
      const reachBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;
      if (reachBottom) {
        this.loadOtherContacts();
      }
    },
    async loadOtherContacts() {
      if (this.loadingOtherContacts) return;
      if (!this.otherContactsHasMore) return;

      const params = {
        limit: this.otherContactsPagination.limit,
        offset: this.otherContactsPagination.offset,
        sortBy: this.otherContactsPagination.sortBy,
        sortOrder: this.otherContactsPagination.sortOrder,
      };

      try {
        this.loadingOtherContacts = true;
        const res = await getAllContact(params);
        const list = res?.result || res?.data?.result || res?.data || [];

        if (Array.isArray(list) && list.length > 0) {
          const mapped = list.map((item) => {
            const id = item?.id ?? item?.contactId ?? item?._id;
            const phone = item?.number ?? item?.phone ?? item?.mobile ?? "";
            const name = item?.name || item?.pushname || item?.pushName || item?.verifiedName || item?.shortName || phone || "";
            const avatar = item?.avatar ?? item?.avatarUrl ?? item?.profilePicUrl ?? item?.picture ?? item?.picUrl ?? "";
            // 提取账号类型 (lid / c.us / g.us 等)
            const accountType = id?.includes("@") ? id.split("@")[1] : "";
            const server = item?.businessProfile?.id?.server || "";
            const dataSource = item?.businessProfile?.dataSource || "";
            return { ...item, id, name, avatar, phone, accountType, server, dataSource };
          });

          // 去重规则：优先按 number(phone) 去重；若 phone 为空则按 id 去重
          // 兼容同一个人可能同时存在 @lid 与 @c.us 两种账号（如果 number 相同，只展示一条）
          const exist = new Set(
            (this.otherContactsInternal || []).map((c) => (c?.phone || c?.id))
          );
          const newItems = mapped.filter((c) => {
            const key = c?.phone || c?.id;
            if (!key) return false;
            if (exist.has(key)) return false;
            exist.add(key);
            return true;
          });
          this.otherContactsInternal = [...(this.otherContactsInternal || []), ...newItems];

          // 后端一次性返回全量联系人：加载一次后关闭后续滚动加载
          this.otherContactsHasMore = false;
        } else {
          this.otherContactsHasMore = false;
        }
      } catch (err) {
        console.error("获取联系人失败", err);
        this.otherContactsHasMore = false;
      } finally {
        this.loadingOtherContacts = false;
      }
    },
    handleClose() {
      if (this.sending) return;
      this.isShow = false;
      this.$emit("close");
    },
    filterContacts(list) {
      if (!this.searchKeyword.trim()) return list;
      const kw = this.searchKeyword.trim().toLowerCase();
      return list.filter(
          (item) =>
              (item.name || "").toLowerCase().includes(kw) ||
              (item.phone || "").includes(kw)
      );
    },
    isSelected(item) {
      return this.selectedIds.includes(item.id);
    },
    toggleSelect(item) {
      const idx = this.selectedIds.indexOf(item.id);
      if (idx > -1) {
        this.selectedIds.splice(idx, 1);
      } else {
        this.selectedIds.push(item.id);
      }
    },
    handleSend() {
      if (this.selectedIds.length === 0) return;
      if (this.sending) return;

      const selected = [
        ...this.recentContacts,
        ...this.otherContactsInternal,
      ].filter((c) => this.selectedIds.includes(c.id));

      this.sending = true;

      const payload = this.forwardPayload;
      const hasSingleMessageId = !!(payload && (payload._id || payload.id));
      const hasMessageList = !!(payload && Array.isArray(payload.messages));

      let messages;
      if (hasMessageList) {
        messages = payload.messages;
      } else if (hasSingleMessageId) {
        messages = [payload];
      }

      this.$emit("send", {
        message: payload,
        ...(messages ? { messages } : {}),
        contacts: selected,
        done: (ok) => {
          const success = ok === true
          this.sending = false;
          if (success) {
            this.isShow = false;
          }
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.forward-message {
  display: inline-block;
}

.forward-message__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 0 0 8px;
  overflow: hidden;

  .search-input {
    flex-shrink: 0;
    margin-bottom: 16px;

    :deep(.el-input__wrapper) {
      width: 100%;
    }
  }

  /* 仅联系人列表区域滚动，避免双重滚动条 */
  .contact-sections {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .contact-section {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .section-title {
    font-size: 12px;
    color: #999;
    margin-bottom: 8px;
  }

  .contact-item {
    display: flex;
    align-items: center;
    padding: 8px 0;
    cursor: pointer;
    gap: 12px;

    &:hover {
      background: #f5f5f5;
      margin: 0 -12px;
      padding: 8px 12px;
    }
  }

  .contact-name {
    flex: 1;
    font-size: 14px;
    color: #333;
  }
}

.forward-message__footer {
  flex-shrink: 0;
  padding-top: 4px;

  .btn-send {
    width: 100%;
    min-height: 32px;
    background: #1890ff !important;
  }
}
</style>

<!-- 弹窗 teleport 到 body，需单独样式 -->
<style lang="scss">
.forward-message-dialog {
  .el-dialog {
    min-height: 680px;
    display: flex;
    flex-direction: column;
  }

  .el-dialog__body {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
  }
}
</style>
